// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  actions: "SectionHero__actions",
  btn: "SectionHero__btn",
  content: "SectionHero__content",
  copy: "SectionHero__copy",
  graphic: "SectionHero__graphic",
  headline: "SectionHero__headline",
  hero: "SectionHero__hero",
  "hero-cue-in": "SectionHero__hero-cue-in",
  "hero-lockup-in": "SectionHero__hero-lockup-in",
  "scroll-hint-pulse": "SectionHero__scroll-hint-pulse",
  scrollHint: "SectionHero__scrollHint",
  stage: "SectionHero__stage",
  standfirst: "SectionHero__standfirst",
};
